<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/4chap1#chap1">PROLOGUE: <i>Friday the Thirteenth in New York</i></a></p>
<p class="toc2"><a href="#/5chap2#chap2">1</a></p>
<p class="toc2"><a href="#/6chap3#chap3">2</a></p>
<p class="toc2"><a href="#/7chap4#chap4">3</a></p>
<p class="toc2"><a href="#/8chap5#chap5">4</a></p>
<p class="toc2"><a href="#/9chap6#chap6">5</a></p>
<p class="toc2"><span href="#/10chap7#chap7" title="Link target outside of Sample">6</span></p>
<p class="toc2"><span href="#/11chap8#chap8" title="Link target outside of Sample">7</span></p>
<p class="toc2"><span href="#/12chap9#chap9" title="Link target outside of Sample">8</span></p>
<p class="toc2"><span href="#/13chap10#chap10" title="Link target outside of Sample">9</span></p>
<p class="toc1"><span href="#/14chap11#chap11" title="Link target outside of Sample">PART ONE: <i>Sex and the Single Demarkian</i></span></p>
<p class="toc2"><span href="#/15chap12#chap12" title="Link target outside of Sample">ONE</span></p>
<p class="toc3"><span href="#/15chap12#chap13" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/15chap12#chap14" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/16chap15#chap15" title="Link target outside of Sample">TWO</span></p>
<p class="toc3"><span href="#/16chap15#chap16" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/16chap15#chap17" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/17chap18#chap18" title="Link target outside of Sample">THREE</span></p>
<p class="toc3"><span href="#/17chap18#chap19" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/17chap18#chap20" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/17chap18#chap21" title="Link target outside of Sample">3</span></p>
<p class="toc2"><span href="#/18chap22#chap22" title="Link target outside of Sample">FOUR</span></p>
<p class="toc3"><span href="#/18chap22#chap23" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/18chap22#chap24" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/19chap25#chap25" title="Link target outside of Sample">FIVE</span></p>
<p class="toc3"><span href="#/19chap25#chap26" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/19chap25#chap27" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/19chap25#chap28" title="Link target outside of Sample">3</span></p>
<p class="toc2"><span href="#/20chap29#chap29" title="Link target outside of Sample">SIX</span></p>
<p class="toc3"><span href="#/20chap29#chap30" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/20chap29#chap31" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/20chap29#chap32" title="Link target outside of Sample">3</span></p>
<p class="toc1"><span href="#/21chap33#chap33" title="Link target outside of Sample">PART TWO: <i>I am Curious, Demarkian</i></span></p>
<p class="toc2"><span href="#/22chap34#chap34" title="Link target outside of Sample">ONE</span></p>
<p class="toc3"><span href="#/22chap34#chap35" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/22chap34#chap36" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/22chap34#chap37" title="Link target outside of Sample">3</span></p>
<p class="toc2"><span href="#/23chap38#chap38" title="Link target outside of Sample">TWO</span></p>
<p class="toc3"><span href="#/23chap38#chap39" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/23chap38#chap40" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/23chap38#chap41" title="Link target outside of Sample">3</span></p>
<p class="toc2"><span href="#/24chap42#chap42" title="Link target outside of Sample">THREE</span></p>
<p class="toc3"><span href="#/24chap42#chap43" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/24chap42#chap44" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/25chap45#chap45" title="Link target outside of Sample">FOUR</span></p>
<p class="toc3"><span href="#/25chap45#chap46" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/25chap45#chap47" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/26chap48#chap48" title="Link target outside of Sample">FIVE</span></p>
<p class="toc3"><span href="#/26chap48#chap49" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/26chap48#chap50" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/26chap48#chap51" title="Link target outside of Sample">3</span></p>
<p class="toc2"><span href="#/27chap52#chap52" title="Link target outside of Sample">SIX</span></p>
<p class="toc3"><span href="#/27chap52#chap53" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/27chap52#chap54" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/27chap52#chap55" title="Link target outside of Sample">3</span></p>
<p class="toc1"><span href="#/28chap56#chap56" title="Link target outside of Sample">PART THREE: <i>Lady Chatterley’s Demarkian</i></span></p>
<p class="toc2"><span href="#/29chap57#chap57" title="Link target outside of Sample">ONE</span></p>
<p class="toc3"><span href="#/29chap57#chap58" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/29chap57#chap59" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/29chap57#chap60" title="Link target outside of Sample">3</span></p>
<p class="toc3"><span href="#/29chap57#chap61" title="Link target outside of Sample">4</span></p>
<p class="toc2"><span href="#/30chap62#chap62" title="Link target outside of Sample">TWO</span></p>
<p class="toc3"><span href="#/30chap62#chap63" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/30chap62#chap64" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/31chap65#chap65" title="Link target outside of Sample">THREE</span></p>
<p class="toc3"><span href="#/31chap65#chap66" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/31chap65#chap67" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/32chap68#chap68" title="Link target outside of Sample">FOUR</span></p>
<p class="toc3"><span href="#/32chap68#chap69" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/32chap68#chap70" title="Link target outside of Sample">2</span></p>
<p class="toc2"><span href="#/33chap71#chap71" title="Link target outside of Sample">FIVE</span></p>
<p class="toc3"><span href="#/33chap71#chap72" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/33chap71#chap73" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/33chap71#chap74" title="Link target outside of Sample">3</span></p>
<p class="toc2"><span href="#/34chap75#chap75" title="Link target outside of Sample">SIX</span></p>
<p class="toc3"><span href="#/34chap75#chap76" title="Link target outside of Sample">1</span></p>
<p class="toc3"><span href="#/34chap75#chap77" title="Link target outside of Sample">2</span></p>
<p class="toc3"><span href="#/34chap75#chap78" title="Link target outside of Sample">3</span></p>
<p class="toc1"><span href="#/35chap79#chap79" title="Link target outside of Sample">Epilogue: <i>Another Friday (Fortunately Not the Thirteenth) This Time in Philadelphia</i></span></p>
<p class="toc2"><span href="#/36chap80#chap80" title="Link target outside of Sample">1</span></p>
<p class="toc2"><span href="#/37chap81#chap81" title="Link target outside of Sample">2</span></p>
<p class="toc1"><span href="#/38preview#preview" title="Link target outside of Sample">Preview: Bleeding Hearts</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?5567214c